import { twMerge } from "tailwind-merge";

import { ClassName } from "shared/types";
import { Button } from "shared/ui/button";
import { Logo } from "shared/ui/logo";

import { NavLink } from "./nav-link";

type Props = {
  buttonClassName?: string;
} & ClassName;

export const Header = ({ className, buttonClassName }: Props) => {
  const from = sessionStorage.getItem("from");
  return (
    <nav className={twMerge("flex items-center bg-transparent", className)}>
      <Logo />
      <ul className="ml-10 flex gap-x-8">
        <li>
          <NavLink to="/">Home</NavLink>
        </li>
        <li>
          <NavLink to="/home">FAQ</NavLink>
        </li>
      </ul>

      <div className="ml-auto flex items-center gap-x-8">
        <NavLink to="/support">Support</NavLink>

        <Button
          as="a"
          className={twMerge(
            "hidden py-2.5 leading-6 md:visible",
            buttonClassName
          )}
          href={from || "https://app.galactica.com"}
          variant="white"
        >
          Back to Galactica.com
        </Button>
      </div>
    </nav>
  );
};
